document.addEventListener('DOMContentLoaded', function() {
  
  function getSizeSortKey(size) {
    if (!size) return 999;
    
    size = size.trim().toUpperCase();
    
    // Clothing sizes
    const clothingSizes = {
      'XS': 2, 'S': 3, 'M': 4, 'L': 5, 'XL': 6, 
      'XXL': 7, 'XXXL': 8, '2XL': 7, '3XL': 8
    };
    
    if (clothingSizes[size]) {
      return clothingSizes[size];
    }
    
    // Numerical sizes
    const numMatch = size.match(/^(\d+)$/);
    if (numMatch) {
      return parseInt(numMatch[1]);
    }
    
    return 999;
  }
  
  function sortVariantOptions() {
    // Athens theme specific selectors
    const sizeSelectors = document.querySelectorAll(
      'select[data-option-position="2"], ' +
      'select[name*="Size"], ' +
      'select[name*="size"], ' +
      '.product-form__option select, ' +
      '.variant-input select'
    );
    
    sizeSelectors.forEach(function(select) {
      // Skip if this isn't a size selector
      const label = select.closest('.product-form__option')?.querySelector('label');
      if (label && !label.textContent.toLowerCase().includes('size') && 
          !label.textContent.toLowerCase().includes('marime')) {
        return;
      }
      
      const options = Array.from(select.options).slice(1); // Skip first "Select size" option
      const firstOption = select.options[0];
      
      if (options.length <= 1) return;
      
      // Sort options by size
      options.sort(function(a, b) {
        const sizeA = getSizeSortKey(a.textContent);
        const sizeB = getSizeSortKey(b.textContent);
        return sizeA - sizeB;
      });
      
      // Clear select and rebuild
      select.innerHTML = '';
      select.appendChild(firstOption);
      
      options.forEach(function(option) {
        select.appendChild(option);
      });
    });
    
    // Handle variant radio buttons/swatches (Athens theme)
    const variantGroups = document.querySelectorAll(
      '.product-form__option:has(input[type="radio"]), ' +
      '.variant-input, ' +
      '.product-form__buttons'
    );
    
    variantGroups.forEach(function(group) {
      const label = group.querySelector('label, .product-form__option-info');
      if (label && !label.textContent.toLowerCase().includes('size') && 
          !label.textContent.toLowerCase().includes('marime')) {
        return;
      }
      
      const buttons = Array.from(group.querySelectorAll('input[type="radio"]'));
      
      if (buttons.length <= 1) return;
      
      buttons.sort(function(a, b) {
        const sizeA = getSizeSortKey(a.value || a.nextElementSibling?.textContent);
        const sizeB = getSizeSortKey(b.value || b.nextElementSibling?.textContent);
        return sizeA - sizeB;
      });
      
      // Reorder in DOM
      buttons.forEach(function(button) {
        const container = button.closest('label') || button.closest('.variant-option') || button.parentElement;
        group.appendChild(container);
      });
    });
  }
  
  // Run on page load
  sortVariantOptions();
  
  // Run again if variants are loaded dynamically (Athens theme uses AJAX)
  const observer = new MutationObserver(function(mutations) {
    let shouldSort = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        shouldSort = true;
      }
    });
    if (shouldSort) {
      setTimeout(sortVariantOptions, 100);
    }
  });
  
  const productForm = document.querySelector('.product-form, .product__form, .product-single__form');
  if (productForm) {
    observer.observe(productForm, { childList: true, subtree: true });
  }
  
  // Handle variant changes (Athens theme specific)
  document.addEventListener('change', function(e) {
    if (e.target.matches('select[data-option-position], input[name*="options"]')) {
      setTimeout(sortVariantOptions, 50);
    }
  });
});
